import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useStyles from './RecentOrderHistory.styles';
import OrderHistoryCard from '../OrderHistoryCard/OrderHistoryCard';
const RecentOrderHistory = (props) => {
    const { classes } = useStyles();
    const { order } = props;
    return (_jsx("div", { className: classes.recentOrderCardContainer, children: _jsxs("div", { className: classes.recentOrder, children: [_jsx("h2", { className: classes.title, children: "Your most recent order" }), !!order ? (_jsx(OrderHistoryCard, { order: order })) : (_jsxs(_Fragment, { children: [_jsx("h3", { className: classes.noOrderTitle, children: "You have no orders yet!" }), _jsx("p", { className: classes.noOrderDescription, children: "But when you do, they will appear here!" })] }))] }) }));
};
export default RecentOrderHistory;
